import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import ChangePassword from "@/pages/ChangePassword";
import AppLayout from "@/components/layout/AppLayout";
import Dashboard from "@/pages/Dashboard";
import Attendance from "@/pages/Attendance";
import Employees from "@/pages/Employees";
import Forms from "@/pages/Forms";
import Approvals from "@/pages/Approvals";
import Announcements from "@/pages/Announcements";
import OrgSettings from "@/pages/OrgSettings";
import Geofence from "@/pages/Geofence";
import Reports from "@/pages/Reports";
import Calendar from "@/pages/Calendar";
import Lifecycle from "@/pages/Lifecycle";
import Profile from "@/pages/Profile";

function Loader() {
  return (
    <div className="flex h-screen items-center justify-center bg-background">
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-primary border-t-transparent" />
    </div>
  );
}

function Protected({ children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace state={{ from: loc }} />;
  if (user.must_change_password) return <Navigate to="/ganti-password" replace />;
  return children;
}

function Routing() {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/ganti-password" element={user ? <ChangePassword /> : <Navigate to="/login" replace />} />
      <Route element={<Protected><AppLayout /></Protected>}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/absensi" element={<Attendance />} />
        <Route path="/karyawan" element={<Employees />} />
        <Route path="/formulir" element={<Forms />} />
        <Route path="/siklus" element={<Lifecycle />} />
        <Route path="/persetujuan" element={<Approvals />} />
        <Route path="/pengumuman" element={<Announcements />} />
        <Route path="/kalender" element={<Calendar />} />
        <Route path="/organisasi" element={<OrgSettings />} />
        <Route path="/geofence" element={<Geofence />} />
        <Route path="/laporan" element={<Reports />} />
        <Route path="/profil" element={<Profile />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routing />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
